(function() {

	// format sliders
	$( '.format-video-slider-wrap' ).not('.slick-initialized').slick({
		infinite : true,
		slidesToShow : 4,
		slidesToScroll : 1,
		arrows : true,
		prevArrow:"<button class='slick-prev slick-arrow' aria-label='Previous Slide'><svg width='35px' height='35px' viewBox='0 0 35 35' version='1.1' xmlns='http://www.w3.org/2000/svg' ><g stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'><g transform='translate(-96.000000, -1193.000000)' stroke='#D0D3D4' stroke-width='5'><g transform='translate(0.000000, 718.000000)'><g transform='translate(98.000000, 477.000000)'><line x1='30.383' y1='15.477' x2='0.5' y2='15.477'></line><polyline points='15.442 30.419 0.5 15.478 15.442 0.536'></polyline></g></g></g></g></svg></button>",
		nextArrow:"<button class='slick-next slick-arrow' aria-label='Next Slide'><svg width='35px' height='35px' viewBox='0 0 35 35' version='1.1' xmlns='http://www.w3.org/2000/svg'><g stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'><g transform='translate(-1309.000000, -1193.000000)' stroke='#D0D3D4' stroke-width='5'><g transform='translate(0.000000, 718.000000)'><g transform='translate(98.000000, 477.000000)'><g transform='translate(1213.000000, 0.000000)'><line x1='0.5' y1='15.477' x2='30.383' y2='15.477'></line><polyline points='15.442 0.536 30.384 15.478 15.442 30.419'></polyline></g></g></g></g></g></svg></button>",
		dots : false,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});

	$( '.format-digital-slider-wrap' ).not('.slick-initialized').slick({
		infinite : true,
		slidesToShow : 4,
		slidesToScroll : 1,
		arrows : true,
		prevArrow:"<button class='slick-prev-digital slick-arrow' aria-label='Previous Slide'><svg width='35px' height='35px' viewBox='0 0 35 35' version='1.1' xmlns='http://www.w3.org/2000/svg' ><g stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'><g transform='translate(-96.000000, -1193.000000)' stroke='#D0D3D4' stroke-width='5'><g transform='translate(0.000000, 718.000000)'><g transform='translate(98.000000, 477.000000)'><line x1='30.383' y1='15.477' x2='0.5' y2='15.477'></line><polyline points='15.442 30.419 0.5 15.478 15.442 0.536'></polyline></g></g></g></g></svg></button>",
		nextArrow:"<button class='slick-next-digital slick-arrow' aria-label='Next Slide'><svg width='35px' height='35px' viewBox='0 0 35 35' version='1.1' xmlns='http://www.w3.org/2000/svg'><g stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'><g transform='translate(-1309.000000, -1193.000000)' stroke='#D0D3D4' stroke-width='5'><g transform='translate(0.000000, 718.000000)'><g transform='translate(98.000000, 477.000000)'><g transform='translate(1213.000000, 0.000000)'><line x1='0.5' y1='15.477' x2='30.383' y2='15.477'></line><polyline points='15.442 0.536 30.384 15.478 15.442 30.419'></polyline></g></g></g></g></g></svg></button>",
		dots : false,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});

	$( '.format-film-slider-wrap' ).not('.slick-initialized').slick({
		infinite : true,
		slidesToShow : 4,
		slidesToScroll : 1,
		arrows : true,
		prevArrow:"<button class='slick-prev-film slick-arrow' aria-label='Previous Slide'><svg width='35px' height='35px' viewBox='0 0 35 35' version='1.1' xmlns='http://www.w3.org/2000/svg' ><g stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'><g transform='translate(-96.000000, -1193.000000)' stroke='#D0D3D4' stroke-width='5'><g transform='translate(0.000000, 718.000000)'><g transform='translate(98.000000, 477.000000)'><line x1='30.383' y1='15.477' x2='0.5' y2='15.477'></line><polyline points='15.442 30.419 0.5 15.478 15.442 0.536'></polyline></g></g></g></g></svg></button>",
		nextArrow:"<button class='slick-next-film slick-arrow' aria-label='Next Slide'><svg width='35px' height='35px' viewBox='0 0 35 35' version='1.1' xmlns='http://www.w3.org/2000/svg'><g stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'><g transform='translate(-1309.000000, -1193.000000)' stroke='#D0D3D4' stroke-width='5'><g transform='translate(0.000000, 718.000000)'><g transform='translate(98.000000, 477.000000)'><g transform='translate(1213.000000, 0.000000)'><line x1='0.5' y1='15.477' x2='30.383' y2='15.477'></line><polyline points='15.442 0.536 30.384 15.478 15.442 30.419'></polyline></g></g></g></g></g></svg></button>",
		dots : false,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});

	$( '.format-photo-slider-wrap' ).not('.slick-initialized').slick({
		infinite : true,
		slidesToShow : 4,
		slidesToScroll : 1,
		arrows : true,
		prevArrow:"<button class='slick-prev-photo slick-arrow' aria-label='Previous Slide'><svg width='35px' height='35px' viewBox='0 0 35 35' version='1.1' xmlns='http://www.w3.org/2000/svg' ><g stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'><g transform='translate(-96.000000, -1193.000000)' stroke='#D0D3D4' stroke-width='5'><g transform='translate(0.000000, 718.000000)'><g transform='translate(98.000000, 477.000000)'><line x1='30.383' y1='15.477' x2='0.5' y2='15.477'></line><polyline points='15.442 30.419 0.5 15.478 15.442 0.536'></polyline></g></g></g></g></svg></button>",
		nextArrow:"<button class='slick-next-photo slick-arrow' aria-label='Next Slide'><svg width='35px' height='35px' viewBox='0 0 35 35' version='1.1' xmlns='http://www.w3.org/2000/svg'><g stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'><g transform='translate(-1309.000000, -1193.000000)' stroke='#D0D3D4' stroke-width='5'><g transform='translate(0.000000, 718.000000)'><g transform='translate(98.000000, 477.000000)'><g transform='translate(1213.000000, 0.000000)'><line x1='0.5' y1='15.477' x2='30.383' y2='15.477'></line><polyline points='15.442 0.536 30.384 15.478 15.442 30.419'></polyline></g></g></g></g></g></svg></button>",
		dots : false,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});

	$( '.mobile-slide-wrapper' ).not('.slick-initialized').slick({
		infinite : false,
		slidesToShow : 1,
		slidesToScroll : 1,
		arrows : true,
		prevArrow: "<button class='slick-prev-outputs slick-arrow' aria-label='Previous Slide'><svg viewBox='0 0 10 16' height='20' width='30'> <g> <g transform='translate(-112.000000, -4152.000000)' > <g fill='#FFFFFF' transform='translate(-55.000000, 0.000000)'> <g transform='translate(0.000000, 3754.000000)'> <g transform='translate(0.000000, 84.000000)'> <g transform='translate(173.500000, 322.500000) scale(-1, 1) translate(-173.500000, -322.500000) translate(145.000000, 294.000000)'> <g> <path d='M34.4475184,28.6174074 L27.3304547,35.7344711 C26.9872043,36.0776858 26.4307367,36.0776858 26.087522,35.7344711 L25.2574339,34.9043831 C24.9147557,34.5617048 24.914112,34.0063459 25.2559677,33.6628809 L30.8963537,27.9959232 L25.2559677,22.3290012 C24.914112,21.9855363 24.9147557,21.4301773 25.2574339,21.0874991 L26.087522,20.257411 C26.4307724,19.9141963 26.9872401,19.9141963 27.3304547,20.257411 L34.4474827,27.3744747 C34.7907331,27.7176894 34.7907331,28.274157 34.4475184,28.6174074 Z'></path> </g> </g> </g> </g> </g> </g> </g> </svg></button>",
		nextArrow: "<button class='slick-next-outputs slick-arrow' aria-label='Next Slide'><svg viewBox='0 0 10 16' height='20' width='30'><g><g transform='translate(-1314.000000, -1763.000000)'><g fill='#FFFFFF' transform='translate(-55.000000, 0.000000)'><g transform='translate(55.000000, 1462.000000)'><g transform='translate(1291.000000, 281.000000)'> <path d='M32.4475184,28.6174074 L25.3304547,35.7344711 C24.9872043,36.0776858 24.4307367,36.0776858 24.087522,35.7344711 L23.2574339,34.9043831 C22.9147557,34.5617048 22.914112,34.0063459 23.2559677,33.6628809 L28.8963537,27.9959232 L23.2559677,22.3290012 C22.914112,21.9855363 22.9147557,21.4301773 23.2574339,21.0874991 L24.087522,20.257411 C24.4307724,19.9141963 24.9872401,19.9141963 25.3304547,20.257411 L32.4474827,27.3744747 C32.7907331,27.7176894 32.7907331,28.274157 32.4475184,28.6174074 Z'></path> </g> </g> </g> </g> </g> </svg></button>",
		dots : false,
		centerMode : true,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 1
				}
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 1
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});

})();
